import {mapState} from 'vuex';
import api from '~/api';
import Cookies from 'js-cookie';

const {
    courseDetailSecond,
    courseDetailButton,
} = api.course || {};

export default {
    data() {
        return {
            coreStatusMap: {
                1: '预约直播',
                3: '停止售卖',
                4: '直播中',
                5: '已预约',
                6: '已预约',
            },
        };
    },
    computed: {
        ...mapState({
            token: state => state.token,
            p_client: state => state.p_client,
            projectName: state => state.projectName,
        }),
        ...mapState('course', {
            goodsPayStatus: state => state.goodsPayStatus,
            promotionUrgeInfo: state => state.promotionUrgeInfo,
            goodsDetailInfo: state => state.goodsDetailInfo,
        }),
        // 需要登录条件：没有token或微信场景下没有unionId
        needLogin() {
            return !this.token;
        },
        // 大班课，0元公开课报名创单
        needCreateOrder() {
            const {coreButton: {courseType, productType, price = -1} = {}} = this.goodsPayStatus || {};
            return productType === 2 && courseType === 1 && price === 0;
        },
        // 商品id，为防止微信封禁链接，B端复制出来的id格式：id_时间戳
        // 通过选择规格切换，query中存在skuNumber，优先使用规格切换的skuNumber
        productNumber() {
            const {params: {id} = {}, query: {skuNumber = ''} = {}} = this.$route;
            return skuNumber || id?.split('_')[0];
        },
        // 考研
        isPubMed() {
            return this.p_client === 12;
        },
        isTuTu() {
            return this.p_client === 2;
        },
        isGtqscz() {
            return this.projectName === 'gtqscz';
        },
        isGaotusuyang() {
            return this.projectName === 'gaotusuyang';
        },
        // 活动价格展示
        promotionPrice() {
            if (!this.promotionUrgeInfo) {
                return null;
            }
            const {promotionPrice} = this.promotionUrgeInfo || {};
            if (!promotionPrice) {
                return null;
            }
            return promotionPrice;
        },
        // 价格展示
        displayPrice() {
            const {minSalePrice = 0, maxSalePrice = 0} = this.goodsDetailInfo;
            let price = 0;
            if (+minSalePrice === +maxSalePrice) {
                price = +minSalePrice === 0 ? '免费' : `${this.fenToYuanInt(minSalePrice, 2)}`;
            }
            else {
                price = `${this.fenToYuanInt(minSalePrice, 2)}-${this.fenToYuanInt(maxSalePrice, 2)}`;
            }
            return price?.indexOf('.00') > -1 ? price?.split('.')[0] : price;
        },
        // 是否免费
        isFree() {
            const {maxSalePrice = 0} = this.goodsDetailInfo;
            return +maxSalePrice === 0;
        },
    },
    methods: {
        // 获取全量详情接口
        async handleGetDetailAll() {
            try {
                const {productNumber} = this;
                const {query: {trace = '', detailType = '', source = '', p_client = 18}} = this.$route;
                const params = {
                    productSpuNumber: productNumber,
                    trace,
                    p_client,
                    fromPC: true,
                };

                if (source) {
                    Cookies.set('__SOURCECHANNEL__', source, {
                        expires: 30,
                        path: '/'
                    });
                }

                const res = await this.$axios.$get(
                    courseDetailSecond,
                    {params}
                );

                const {code, data = {}} = res || {};
                if (code === 0) {
                    this.$store.commit('course/SET_GOODS_DETAIL_INFO', data);
                    return data;
                }
            }
            catch (e) {
                console.log(e);
            }
        },

        // 获取底部按钮状态
        async handleGetButtonInfo({skuNumber = '', price} = {}) {
            const {productNumber} = this;
            const {query: {trace = '', detailType = '', p_client = 18}} = this.$route;
            const productSpuNumber = skuNumber || productNumber;
            const params = {
                productSpuNumber,
                trace,
                p_client,
                fromPC: true,
            };
            try {
                const res = await this.$axios.$get(
                    courseDetailButton,
                    {params}
                );
                const {code, data = {}} = res;
                const {clazzSwitch = 0} = data;
                // 是否切换旧大班课开关，0-不切换，1-切换
                if (+clazzSwitch) {
                    this.$router.replace({path: `/learn/${productNumber}`, query: {...this.$route.query}});
                    return;
                }
                if (code === 0) {
                    this.$store.commit('course/SET_GOODS_PAY_STATUS', data);
                    return;
                }
                this.$store.commit('course/SET_GOODS_PAY_STATUS', {
                    coreButton: {
                        status: 1,
                    }
                });
            }
            catch (e) {
                this.$store.commit('course/SET_GOODS_PAY_STATUS', {
                    coreButton: {
                        status: 1,
                    }
                });
            }
        },

        // 执行报名按钮操作
        handleGetBtnAction() {
            const {coreButton: {status} = {}} = this.goodsPayStatus;
            const getDescribe = this.describeBtnMap?.find(item => item[0](status));
            return getDescribe && getDescribe[2]();
        },

        // 判断是否为空对象
        isEmpty(obj) {
            return Object.keys(obj).length === 0;
        },

        // 价格展示
        fenToYuanInt(value, precision = 0) {
            // precision精度必传
            value = +value;
            if (typeof value !== 'number' || isNaN(value)) {
                return null;
            }
            if (value <= 0) {
                return 0;
            }
            return (value * 0.01).toFixed(precision);
        },
    }
};
